import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import StorefrontServiceabilityGate from './StorefrontServiceabilityGate';
import UnserviceableLocationPage from './UnserviceableLocationPage';
import { useDeliveryLocation } from '../context/DeliveryLocationContext';
import { containerNarrow, pageSection } from '../styles/ui';

// Route wrapper for storefront pages (listing, product, search, favourites),
// in the same spirit as ProtectedRoute. Once an outlet serves the browsing
// location the page renders — remounted per geography, so it always loads that
// location's data. Until then the page is replaced by the gate, inside the
// usual header and footer, so no other location's products can be acted on.
const StorefrontRoute = ({ children }) => {
  const { storefrontStatus } = useDeliveryLocation();

  if (storefrontStatus === 'ready') {
    return <StorefrontServiceabilityGate>{children}</StorefrontServiceabilityGate>;
  }

  // The backend has answered: nobody delivers to this location. The whole
  // page (header and footer included) becomes the "not yet" view.
  if (storefrontStatus === 'unserviceable') {
    return <UnserviceableLocationPage />;
  }

  return (
    <>
      <Navbar />
      <section className={pageSection}>
        <div className={containerNarrow}>
          <StorefrontServiceabilityGate />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default StorefrontRoute;
